import { transparentColors } from '@assets/styles/helpers/colors.styles'

export const modalStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  background: transparentColors.whiteShade3,
  borderRadius: '0.5rem',
  border: 0,
  outline: 0,
  p: '1.5rem 2rem',
  zIndex: 6
}

export const modalBackgroundStyles = {
  backdropFilter: 'blur(6px)',
  backgroundColor: transparentColors.blackShade1,
  zIndex: 5
}
